import KumocanDialog from 'components/dialog'
import SurveyV2 from 'pages/assign/components/questions/surveyV2'

interface Props {
  id: string
  open: boolean
  setOpen: (v: boolean) => void
}

export default function Review(props: Props): JSX.Element {
  const handleClose = () => {
    props.setOpen(false)
  }

  return (
    <KumocanDialog open={props.open} height="600px" minWidth="95vw">
      <SurveyV2 assignId={props.id} onClose={handleClose} />
    </KumocanDialog>
  )
}
